import { ReactElement, useEffect, useState } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { GoForwardButton } from '../../GoForwardButton';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { CartIcon } from '../../../icons/CartIcon';
import Loading from '../../../icons/Loading';
import { ErrorModal } from '../../../Modal/Modal';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { useError } from '../../../../stores/useError';
import { useRouteLoaderData } from 'react-router-dom';

export function AceiteForm(): ReactElement {
  const { handleSubmit, onSubmit } = useHirePlanForm();

  const width = useWindowSizeStore(state => state.width);
  const produtosGDF = [993, 994, 998, 999, 1000];

  const data: any = useRouteLoaderData('token-servidor');

  const loading = useLoadingStore(state => state.loading);
  const error = useError(state => state.error);
  const title = useError(state => state.title);
  const text = useError(state => state.text);

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(onSubmit)}
    >
      {error && <ErrorModal open={true} title={title} text={text} />}
      {produtosGDF.includes(data?.produtoComercial?.id_prodcomerc) ? (
        <>
          <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
            Termo de aceite
          </h2>
          <p className="font-normal mt-1 text-justify mb-8">
            Confirmo minha adesão ao Auxílio Odontológico oferecido pelo Governo
            do Distrito Federal, conforme disposto no Diário Oficial de julho de
            2024 (Lei Nº 7.524 e Decreto Nº 46.102 de agosto de 2024).
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            O plano odontológico é 99% subsidiado para servidores titulares
            estaduais da administração direta, autárquica e fundacional do DF e
            está sendo disponibilizado através da Odontogroup Sistema de Saúde
            Ltda., operadora credenciada.
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            Estou ciente que o plano não possui carência e requer uma
            permanência mínima de 12 meses.E reforço que estou ciente de que os
            meus dados pessoais serão tratados conforme as disposições da Lei
            Geral de Proteção de Dados (LGPD).
          </p>
        </>
      ) : (
        <>
          <h2 className="text-[2rem] font-semibold text-left text-primary-main notranslate">
            Termo de aceite
          </h2>
          <p className="font-normal mt-1 text-justify mb-8">
            Confirmo minha adesão ao Auxílio Odontológico oferecido pelo DNIT,
            conforme disposto publicado no EDITAL DE CHAMAMENTO PÚBLICO Nº
            25/2024 - INEXIGIBILIDADE Nº 163/2024. Através da Odontogroup
            Sistema de Saúde Ltda., operadora credenciada.
          </p>
          <p className="font-normal mt-1 text-justify mb-8">
            Estou ciente que o plano não possui carência e requer uma
            permanência mínima de 12 meses. E reforço que estou ciente de que os
            meus dados pessoais serão tratados conforme as disposições da Lei
            Geral de Proteção de Dados (LGPD).
          </p>
          <p className="font-normal font-size-sm mt-1 text-justify mb-8">
            Clicando no “Estou de acordo”, aceito os termos da politica de
            privacidade da odontogroup{' '}
            <a
              href="https://odontogroup.com.br/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-primary-main"
            >
              publicado aqui.
            </a>
          </p>
        </>
      )}
      <GoForwardButton
        disabled={loading}
        addBackButton
        Icon={loading ? Loading : CartIcon}
        desktopText={loading ? '' : 'Estou de Acordo'}
        mobileText={loading ? '' : 'Estou de Acordo'}
      />
    </form>
  );
}
